"use client";

type StoryblokImageLoaderProps = {
  src: string;
  width: number;
  height?: number;
  quality?: number;
  focus?: string | null;
};

export default function imageLoader({
  src,
  width,
  quality,
}: StoryblokImageLoaderProps) {
  let url: URL | null = null;

  try {
    url = new URL(src);
  } catch (err) {}

  // We only want to apply this to storyblok images
  if (!url || url.host !== "a.storyblok.com") return src;

  const aspectRatioParam = url.searchParams.get("r");
  const aspectRatio = aspectRatioParam
    ? Number.parseFloat(aspectRatioParam)
    : null;

  const heightParam = url.searchParams.get("h");
  let height = aspectRatio
    ? Math.round(width / aspectRatio)
    : heightParam
      ? Number.parseFloat(heightParam)
      : heightParam;

  if (height == null || Number.isNaN(height)) height = 0;

  const focus = url.searchParams.get("f");

  const filters = new Map();

  filters.set("quality", quality || 75);

  if (focus) {
    filters.set("focal", focus);
  }

  const filterValues = Array.from(filters)
    .map(([key, val]) => `${key}(${val})`)
    .join(":");

  // Clean out the params used for passing state to loader
  url.searchParams.delete("r");
  url.searchParams.delete("h");
  url.searchParams.delete("f");

  url.pathname = `${url.pathname}/m/${width}x${height}/filters:${filterValues}`;

  return url.href;
}
